export default {
  beforeCreate () {
    window.addEventListener('popstate', (e) => {
      if (e.state.custom) {
        history.replaceState(null, document.title, this.location.pathname)
        setTimeout(function () {
          this.location.replace('/login' + this.location.search + this.location.hash)
        }, 0)
      }
    }, false)
  },
  computed: {
    location () {
      return window.location
    }
  },
  watch: {
    location: {
      immediate: true,
      deep: true,
      handler (val) {
        this.markHistory(val)
      }
    }
  },
  methods: {
    markHistory (location) {
      history.replaceState({ custom: true }, document.title, location.toString())
      history.pushState({ custom: false }, document.title, location.toString())
    }
  }
}
